<template>
  <div class="link-toggle-wrapper">
    <p class="link-toggle-text"
       @click="setOpenStatus">&#8805; {{linkText}} {{linkText | pluralize(linkId)}}</p>
    <div :class="['link-toggle', { open: isOpen }]">
      <slot name="linkToggle"></slot>
    </div>
  </div>
</template>


<script>
  export default {
    props: {
      openStatus: Boolean,
      linkId: [Number, String],
      linkText: [Number, String],
    },

    name: 'LinkToggle',

    components: {
    },

    data() {
      return {
        isOpen: false,
      }
    },

    methods: {
      setOpenStatus: function() {
        this.isOpen = !this.isOpen
        this.$emit('setOpenStatus', this.isOpen)
      }
    },

    watch: {
      openStatus: function() {
        this.isOpen = this.openStatus
      }
    }
  }
</script>
